export default __webpack_public_path__ + "assets/ogg/34cc5e84d4aab4fb3b8a65c807b98021.ogg";